import {
	useFamilyMemberInterviewWizard,
	FamilyMemberInterviewProvider,
} from './useFamilyMemberInterviewWizard';
import { LandingPage } from './LandingPage';
import { WizardProvider } from '../../../components/wizard/useWizard';

export const FamilyContextPolicy = () => {
	const { application } = useFamilyMemberInterviewWizard();
	const { applicant, familyMemberReference } = application;
	return (
		<div className="flex flex-col h-full min-h-0 p-[8px]">
			<LandingPage
				applicantInfo={applicant}
				familyReference={familyMemberReference}
			/>
		</div>
	);
};

export const FamilyMemberContextWizardContainer = () => {
	return (
		<FamilyMemberInterviewProvider>
			<WizardProvider>
				<FamilyContextPolicy />
			</WizardProvider>
		</FamilyMemberInterviewProvider>
	);
};
